import Papa from "papaparse";
import { formatReportJsonValue } from "./report-value-format";
import { formatDate } from "./utils";

export type CsvColumn = {
  key: string;
  label: string;
  type?: string;
};

const normalizeExcelCellText = (value: string) =>
  value.replace(/\r?\n/g, " | ");

const normalizeCsvValue = (value: any, column?: CsvColumn) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  if ((column?.type === "date" || column?.type === "datetime") && value) {
    return formatDate(value, "DD-MMM-YYYY");
  }
  if (column?.type === "json") {
    return normalizeExcelCellText(formatReportJsonValue(value, column.key));
  }
  if (typeof value === "object") {
    return normalizeExcelCellText(formatReportJsonValue(value, column?.key));
  }
  return value;
};

export const exportCsv = (
  fileName: string,
  rows: any[],
  columns: CsvColumn[]
) => {
  const csvRows = rows.map((row) => {
    const csvRow: Record<string, any> = {};

    columns.forEach((column) => {
      csvRow[column.label] = normalizeCsvValue(row[column.key], column);
    });

    return csvRow;
  });

  const csv = Papa.unparse(csvRows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
